import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { ClickOutside } from '../../helpers'
import { IconNotifications } from './icons'
import { ProfileNavItems } from '../profile/profile-nav'
import { ROUTER } from '../../config'
import styles from './HeaderUserPanel.module.scss'

const HeaderUserPanel = ({ navStatus, history }) => {
  const userData = useSelector(state => state.userData)
  const isUserOnline = useSelector(state => state.userOnline)

  // info notifications
  const infoRef = useRef(null)
  const [infoNotifications, setInfoNotifications] = useState(false)
  const hideNotifications = () => setInfoNotifications(false)
  ClickOutside(infoRef, hideNotifications)

  // menu
  const avatarRef = useRef(null)
  const [dropDownState, setDropDownState] = useState(false)
  const hideDropDown = () => setDropDownState(false)
  ClickOutside(avatarRef, hideDropDown)

  // return if no data
  if (!userData || !isUserOnline) return null

  return (
    <div
      className={classNames(styles.headerUserPanel, {
        [styles.hidden]: navStatus,
      })}
      data-testid='header-user-panel'
    >
      <div
        ref={infoRef}
        className={classNames(styles.item, {
          [styles.isActive]: infoNotifications,
        })}
      >
        <div
          className={styles.iconHolder}
          onClick={() => history.push(ROUTER.notifications)}
          data-testid='notifications-button'
        >
          <IconNotifications />

          {userData?.notification && (
            <div
              className={styles.notificationsCounter}
              data-testid='notifications-counter'
            >
              {userData?.notification}
            </div>
          )}
        </div>
      </div>
      <div ref={avatarRef} className={styles.item}>
        <div
          className={classNames(styles.avatar, {
            [styles.withImage]: userData.avatar,
            [styles.defaultImage]: !userData.avatar,
          })}
          style={
            userData.avatar
              ? { '--avatar-image': `url(${userData.avatar})` }
              : {}
          }
          onClick={() => setDropDownState(!dropDownState)}
          data-testid='user-avatar'
        />
        {dropDownState && (
          <ul
            className={classNames(styles.dropDownList, 'headerDropMainColor')}
            data-testid='user-dropdown-menu'
          >
            {ProfileNavItems(hideDropDown, history)}
          </ul>
        )}
      </div>
    </div>
  )
}

export default withRouter(HeaderUserPanel)

HeaderUserPanel.propTypes = {
  navStatus: PropTypes.bool.isRequired,
}
